export default __webpack_public_path__ + "static/media/bryan.c21bccc7.PNG";